// Shared option lists for the German payroll inputs. The values match the ones the backend
// expects in utils/lohnsteuer/payroll.js.

export const STEUERKLASSEN = [
  { value: 1, label: "I — Single / separated" },
  { value: 2, label: "II — Single parent (Entlastungsbetrag)" },
  { value: 3, label: "III — Married, higher earner" },
  { value: 4, label: "IV — Married, similar earnings" },
  { value: 5, label: "V — Married, lower earner" },
  { value: 6, label: "VI — Second or further employment" }
];

// Two-letter codes as used by the backend: they drive the Kirchensteuer rate (8 % in Bayern
// and Baden-Württemberg, otherwise 9 %) and the Pflegeversicherung split in Sachsen.
export const BUNDESLAENDER = [
  { value: "BW", label: "Baden-Württemberg" },
  { value: "BY", label: "Bayern" },
  { value: "BE", label: "Berlin" },
  { value: "BB", label: "Brandenburg" },
  { value: "HB", label: "Bremen" },
  { value: "HH", label: "Hamburg" },
  { value: "HE", label: "Hessen" },
  { value: "MV", label: "Mecklenburg-Vorpommern" },
  { value: "NI", label: "Niedersachsen" },
  { value: "NW", label: "Nordrhein-Westfalen" },
  { value: "RP", label: "Rheinland-Pfalz" },
  { value: "SL", label: "Saarland" },
  { value: "SN", label: "Sachsen" },
  { value: "ST", label: "Sachsen-Anhalt" },
  { value: "SH", label: "Schleswig-Holstein" },
  { value: "TH", label: "Thüringen" }
];

export const PERIODS = [
  { value: "month", label: "Per month" },
  { value: "year", label: "Per year" },
  { value: "week", label: "Per week" },
  { value: "day", label: "Per day" }
];

const currency = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

/** Amounts travel as integer cents so the UI never rounds money itself. */
export const formatCents = cents => currency.format((Number(cents) || 0) / 100);
